import { Directive, ElementRef, Input } from "@angular/core";
import { BooleanAttribute } from "@hex/angular/decorators";
import { FlagsRef } from "./flags.service";

@Directive({
    selector: "[ispAssociatedFeature],[ispHideFeature]",
})
export class FeatureFlagDirective {
    @Input()
    public set ispAssociatedFeature(value: string) {
        if (this.flags.isOff(value)) {
            this.elementRef.nativeElement.remove();
        }
    }

    @Input()
    @BooleanAttribute()
    public set ispHideFeature(value: boolean) {
        if (value === true) {
            this.elementRef.nativeElement.remove();
        }
    }

    constructor(
        public elementRef: ElementRef,
        public flags: FlagsRef,
    ) { }

}
